import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastyService } from 'ng2-toasty';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-memory',
  templateUrl: './memory.component.html',
  styleUrls: ['./memory.component.scss']
})
export class MemoryComponent implements OnInit {

  @Input() interaction: Interaction
  @Output() addInteraction = new EventEmitter();

  memoryForm = new FormGroup({
    titolo: new FormControl('', [Validators.required]),
    sottotitolo: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    info: new FormControl('')
  });
  constructor(private toastyService: ToastyService) { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'memory'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.memoryForm.controls;
  }

  populateForm(): void {
    this.f.titolo.setValue(this.interaction.title);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    this.f.sottotitolo.setValue(this.interaction.subtitle);
  }

  validateTitolo(): boolean {
    return !this.f.titolo.errors && !this.f.sottotitolo.errors;
  }

  setTitolo(): void {
    this.interaction.title = this.f.titolo.value;
    this.interaction.subtitle = this.f.sottotitolo.value;
  }

  setImmagineRisposta(index, event): void {
    if (event) {
      if (this.interaction.interactionData.risposte.find(r => r.image === event.filename)) {
        this.interaction.interactionData.risposte.splice(index);
        this.toastyService.warning({
          title: 'Hai già utilizzato questa immagine!',
          msg: 'Carica immagini diverse all\'interno di una Interaction Memory'
        });
      } else {
        this.interaction.interactionData.risposte[index].image = event.filename;
      }
    } else {
      this.interaction.interactionData.risposte[index].image = null;
    }
  }

  deleteRisposta(risposta): void {
    this.interaction.interactionData.risposte = this.interaction.interactionData.risposte.filter(r => r.image !== risposta)
  }

  validateRisposte(): boolean {
    let valid = true;
    if (!this.interaction.interactionData.risposte.length) {
      valid = false;
    } else {
      if (this.interaction.interactionData.risposte.length < 3) {
        valid = false;
      }
      this.interaction.interactionData.risposte.forEach(r => {
        if (!r.image) {
          valid = false;
        }
      });
    }
    return valid;
  }

  onAddInteraction(): void {
    this.interaction.interactionData.info = this.f.info.value;
    this.interaction.interactionData.coordinates = {
      lat: this.f.lat.value,
      lng: this.f.lng.value
    }
    this.addInteraction.emit(this.interaction);
  }

}
